// Canonical launch adapter. Generated into both app trees; no payment state changes.
export function usesMobilePaymentHandoff(userAgent: string, platform: string, touchPoints: number) {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent)
    || (platform === 'MacIntel' && touchPoints > 1);
}

export function paymentAppUrl(url: string): string {
  // Venmo's mobile HTTPS redirect serializes spaces as "+" in paycharge notes.
  // Build the same app target directly, encoding each decoded value exactly once.
  const match = /^https:\/\/venmo\.com\/([^/?#]+)\/?\?([^#]*)$/i.exec(url);
  if (!match) return url;
  try {
    const recipient = decodeURIComponent(match[1]).replace(/^@/, '');
    const params = new URLSearchParams(match[2]);
    if (!/^[a-z0-9_-]{1,30}$/i.test(recipient) || !['pay', 'charge'].includes(params.get('txn') || '')) return url;
    params.set('recipients', recipient);
    const query: string[] = [];
    params.forEach((value, key) => query.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`));
    return `venmo://paycharge?${query.join('&')}`;
  } catch { return url; }
}
